import HSGFooter from './Component/HSGFooter'


export default HSGFooter

